var MultiGeometryViewBase = require('../base/multi-geometry-view-base');
var PointView = require('./point-view');

var MultiPointView = MultiGeometryViewBase.extend({
  GeometryViewClass: PointView
});

module.exports = MultiPointView;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/geometry-views/leaflet/multi-point-view.js
// module id = 1638
// module chunks = 6